// src/directives/scrollAnimate.js
export default {
    inserted (el, binding) {
        el.classList.add("opacity-0"); // 确保初始不可见
  
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    el.classList.remove("opacity-0");
                    el.classList.add("animate__animated", binding.value);
                    observer.disconnect(); // 只触发一次动画
                }
            },
            { threshold: 0.1 } // 10% 进入视口时触发
        );
  
        observer.observe(el);
    }
};
  